import type { JSONDocNode } from '@atlaskit/editor-json-transformer';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { getTraceId } from '@atlassian/jira-fetch/src/utils/trace-id.tsx';

export const FLAG_WITH_COMMENT_URL = '/rest/greenhopper/3/xboard/issue/flag/flag';

const noContentStatus = 204;

export const saveFlagWithComment = (
	issueKeys: string[],
	flag: boolean,
	comment: JSONDocNode,
): Promise<null> =>
	fetch(FLAG_WITH_COMMENT_URL, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			issueKeys,
			flag,
			comment,
			commentProperty: '',
			commentVisibility: '',
		}),
	}).then((response) => {
		if (!response.ok) {
			const { status } = response;
			const traceId = getTraceId(response);
			if (traceId != null && traceId !== '') {
				throw new FetchError(status, `Fetch call failed with status code: ${status}`, traceId);
			} else {
				throw new FetchError(status);
			}
		}

		if (response.status === noContentStatus) {
			return null;
		}
		return response.text().then((body) => {
			const result = body ? JSON.parse(body) : null;

			if (result) {
				const errorMessage = result.errorMessages
					? result.errorMessages.join(', ')
					: 'Unidentified error when saving flag with comment';

				throw new Error(errorMessage);
			}

			return null;
		});
	});
